interface KpiTilesProps {
  totalSqFt: number;
  squares: number;
  orderSquares: number;
  primaryPitch: string;
  complexity: "Simple" | "Moderate" | "Complex";
  stories?: number;
}

export function KpiTiles({ totalSqFt, squares, orderSquares, primaryPitch, complexity, stories = 1 }: KpiTilesProps) {
  const tiles = [
    { label: "Total SQ FT", value: totalSqFt.toLocaleString(), accent: false },
    { label: "Squares", value: squares.toString(), accent: true },
    { label: "Order SQ +20% waste", value: orderSquares.toString(), accent: false },
    { label: "Primary Pitch", value: primaryPitch, accent: false },
    { label: "Complexity", value: complexity, accent: complexity === "Complex" },
  ];

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <span>{stories}-story</span>
        <span className="px-2 py-0.5 rounded-full bg-destructive/10 text-destructive font-medium">{complexity}</span>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-5">
        {tiles.map((t) => (
          <div
            key={t.label}
            className={`rounded-xl border p-3 text-center ${
              t.accent ? "bg-destructive/5 border-destructive/20" : "border-border bg-card"
            }`}
          >
            <div className={`break-words text-xl font-bold ${t.accent ? "text-destructive" : "text-foreground"}`}>
              {t.value}
            </div>
            <div className="mt-1 break-words text-[10px] uppercase tracking-wide text-muted-foreground leading-tight">
              {t.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
